import angular from 'angular';
import _ from 'lodash';
import uiRouter from '@uirouter/angularjs';
import routing from './end_user_create.routes';
import EndUserService from '../../../components/api/end_user/end_user.service';
import SaConfigService from '../../../components/api/sa_config/sa_config.service';
import ControllerConfigService from '../../../components/api/controller_config/controller_config.service';

export class EndUserCreateController {
  /*@ngInject*/
  constructor(EndUserService, SaConfigService, ControllerConfigService, $state, $mdDialog, $templateCache, $q) {
    this.EndUserService = EndUserService;
    this.SaConfigService = SaConfigService;
    this.ControllerConfigService = ControllerConfigService;
    $templateCache.put('role_table.html', require('./../role_table.html'));
    this.userData = {};
    this.userData.role = "viewer";
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$q = $q;
    this.devices = [];
    this.selectedIds = [];
  }

  $onInit() {
    this.$q.all([
      this.SaConfigService.api.index().$promise,
      this.ControllerConfigService.api.index().$promise
    ]).then(responses => {
      this.devices = responses[0].concat(responses[1]);
    });
  }

  showConfirm(userData, ev, $mdDialog) {
    let dialog = {
      confirm: $mdDialog.confirm({
        clickOutsideToClose: true,
        title: '作成しますか？',
        ok: '作成する',
        cancel: '設定に戻る'
      }),
      error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントの作成に失敗しました',
        content: '入力内容を確認してください',
        ok: 'OK'
      }),
      duplication_error: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントの作成に失敗しました',
        content: '入力されたメールアドレスは既に登録されています。',
        ok: 'OK'
      }),
      success: $mdDialog.alert({
        clickOutsideToClose: true,
        title: 'アカウントを作成しました',
        content: `${this.userData.email} 宛にパスワード設定用のURLが通知されます。`,
        ok: 'OK'
      })
    };

    if(userData.role === 'limited_viewer') {
      _.merge(userData, { config_ids: this.selectedIds });
    }

    this.$mdDialog.show(dialog.confirm.targetEvent(ev)).then(() => {
      this.EndUserService.api.create(
        userData,
        (okResponse) => { this.$mdDialog.show(dialog.success).finally(() => { this.$state.go('main.end_user_index'); }); },
        (errResponse) => {
          if (errResponse.data.message.email && errResponse.data.message.email[0] === 'address is already in use') {
            this.$mdDialog.show(dialog.duplication_error);
          } else {
            this.$mdDialog.show(dialog.error);
          }
        }
      );
    })
  };
}

export default angular.module('leptonApp.endUserCreate', [uiRouter, EndUserService, SaConfigService, ControllerConfigService])
  .config(routing)
  .component('endUserCreate', {
    template: require('./end_user_create.html'),
    controller: EndUserCreateController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/end_user/create/end_user_create.component.js